import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBell2"><Path d="M20.5 17.5H3.5V16.25L5.09375 13L5.30665 8.82543C5.48498 5.28203 8.42883 2.5 12 2.5C15.5712 2.5 18.515 5.28203 18.6934 8.82543L18.9062 13L20.5 16.25V17.5Z" stroke="currentColor"/><Path d="M8.00659 17.7322C8.12687 19.8332 9.86878 21.4999 12 21.4999C14.1311 21.4999 15.8731 19.8332 15.9933 17.7322" stroke="currentColor"/></CentralIconBase>;
});

export default IconBell2;
